import { readFile } from 'node:fs/promises'
import { join } from 'node:path'
import { existsSync } from 'node:fs'
import { parse as parseYaml } from 'yaml'
import { resolveScenariosDir } from '../workspace.js'
import { loadScenarioConfig } from './loader.js'
import type { ScenarioInfo } from './types.js'

interface RegistryEntry {
  name: string
  repo: string
  commit: string
  description: string
  difficulty: 'easy' | 'medium' | 'hard'
  estimated_time: string
}

interface RegistryFile {
  scenarios: RegistryEntry[]
}

async function getScenariosPackagePath(): Promise<string> {
  const dir = await resolveScenariosDir()
  if (dir) return dir
  throw new Error('Could not locate @tonty/scenarios package')
}

export async function discoverBuiltInScenarios(): Promise<ScenarioInfo[]> {
  const scenariosPath = await getScenariosPackagePath()
  const registryPath = join(scenariosPath, 'registry.yaml')

  if (!existsSync(registryPath)) {
    return []
  }

  const raw = await readFile(registryPath, 'utf-8')
  const registry = parseYaml(raw) as RegistryFile

  if (!registry.scenarios || !Array.isArray(registry.scenarios)) {
    return []
  }

  const scenarios: ScenarioInfo[] = []

  for (const entry of registry.scenarios) {
    const scenarioConfigPath = join(scenariosPath, entry.name, 'scenario.yaml')

    if (existsSync(scenarioConfigPath)) {
      const config = await loadScenarioConfig(scenarioConfigPath)
      scenarios.push({
        name: entry.name,
        config,
        builtIn: true,
      })
    } else {
      console.warn(
        `Warning: scenario "${entry.name}" listed in registry but ${scenarioConfigPath} not found`,
      )
    }
  }

  return scenarios
}

export async function discoverAllScenarios(): Promise<ScenarioInfo[]> {
  return discoverBuiltInScenarios()
}
